import { useQuery } from "@tanstack/react-query";
import { Space, Typography, Collapse } from "antd";
import { Link } from "react-router-dom";
import { fetchFaqs } from "../../../lib/api/resources/faq";
import { useCurrentUser } from "../../../lib/hooks/useCurrentUser";
import { Button, Card } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const FaqsList = () => {
  const currentUser = useCurrentUser();

  const faqsQuery = useQuery({
    queryKey: ["faqs"],
    queryFn: () => fetchFaqs({ pagination: false }),
    select: (data) => {
      return data?.member?.map((faq) => ({
        key: faq.id,
        label: <strong>{faq.question}</strong>,
        extra: currentUser?.permissions?.includes("admin_faq_create") && (
          <Link to={`/faqs/${faq.id}/edit`}>Bewerken</Link>
        ),
        children: <Typography.Text>{faq.answer}</Typography.Text>,
      }));
    },
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        {currentUser?.permissions?.includes("admin_faq_create") && (
          <Link to="/faqs/create">
            <Button icon={<PlusOutlined />}>
              Nieuwe vraag & antwoord toevoegen
            </Button>
          </Link>
        )}
      </Space>
      <Card title="Algemene vragen" loading={faqsQuery.isFetching}>
        <Collapse bordered={false} items={faqsQuery.data} />
      </Card>
    </div>
  );
};
